import { render, staticRenderFns } from "./MLivesMain.vue?vue&type=template&id=0c1fa989"
import script from "./MLivesMain.vue?vue&type=script&lang=js"
export * from "./MLivesMain.vue?vue&type=script&lang=js"
import style0 from "./MLivesMain.vue?vue&type=style&index=0&id=0c1fa989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports